import { render, staticRenderFns } from "./SubTasksListing.vue?vue&type=template&id=2f6fb1cb"
import script from "./SubTasksListing.vue?vue&type=script&lang=js"
export * from "./SubTasksListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports